import { IQueryParams } from '@/types'

class MedicalRecordParamsMapper {
  toPersistence(domainData: IQueryParams) {
    const endDateFormated = `${
      String(domainData?.endDate)?.split(' ')[0]
    } 23:59:59`

    return {
      clinicId: domainData?.clinicId.toString(),
      patientId: domainData?.patientId.toString(),
      initialDate: domainData?.initialDate,
      endDate: endDateFormated,
      idProfessionals: domainData?.professionalsId,
      councils: domainData?.councils,
      specialties: domainData?.specialties,
      councilsId: domainData?.councilsId,
      outcome: domainData?.outcome,
      status: domainData?.status,
    }
  }
}

export default new MedicalRecordParamsMapper()
